import { Component, input } from '@angular/core';

@Component({
  template: '{{ text() }}',
  standalone: true,
})
export class TableDynamicNodeTextComponent {
  readonly text = input<string>('');
}
